import type { Product, ProductVariant } from '@/services/products'

function distinctSwatchIdentityCount(product: Product): number {
  const rows = product.variant_swatches ?? []
  const seen = new Set<string>()
  for (const r of rows) {
    const attrs = r.attributes || {}
    const vals = Object.values(attrs)
      .map((v) => String(v ?? '').trim())
      .filter(Boolean)
    const firstVal = vals[0] || ''
    const key = firstVal || r.id
    if (seen.has(key)) continue
    seen.add(key)
  }
  return seen.size
}

/**
 * Catalog / grid payloads may omit `variants[]` but include `variant_count` or `variant_swatches`.
 * True when the shopper must pick among more than one SKU.
 */
export function catalogProductNeedsVariantChoice(product: Product): boolean {
  const n = product.variants?.length ?? 0
  if (n > 1) return true
  if (n === 1) return false
  const vc = product.variant_count
  if (typeof vc === 'number') {
    if (vc > 1) return true
    if (vc === 1) return false
  }
  if (!product.has_variants) return false
  return distinctSwatchIdentityCount(product) > 1
}

export function selectableVariantCount(variants: Pick<ProductVariant, 'status'>[]): number {
  return variants.filter((v) => v.status !== 'archived' && v.status !== 'inactive').length
}

/** PDP / payloads with full variant rows: show selectors only when there is a real choice. */
export function storefrontPayloadNeedsVariantSelectors(payload: { variants: Pick<ProductVariant, 'status'>[] }): boolean {
  return selectableVariantCount(payload.variants) > 1
}
